import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { UrlHelper } from '@/utils/UrlHelper';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { SuperAdminDataLookupListResponseDto } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

export const useSuperAdminDataOwnersLookupApi = (tenantId: string | null, searchText?: string) => {
    const axiosInstance = useAxiosAuth();

    return useQuery({
        queryKey: [ApiConfig.queries.superAdmin.data.lookups.queryKeys.owners, tenantId, searchText],
        queryFn: async (): Promise<SuperAdminDataLookupListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(
                ApiConfig.queries.superAdmin.data.lookups.endpoints.owners,
                { tenantId, searchText, take: 100, skip: 0 },
            );
            const response = await axiosInstance.get<SuperAdminDataLookupListResponseDto>(url);
            return response.data;
        },
        enabled: Boolean(tenantId),
    });
};

export const useSuperAdminDataApartmentsLookupApi = (
    tenantId: string | null,
    searchText?: string,
    hotelId?: string | null,
) => {
    const axiosInstance = useAxiosAuth();

    return useQuery({
        queryKey: [
            ApiConfig.queries.superAdmin.data.lookups.queryKeys.apartments,
            tenantId,
            searchText,
            hotelId,
        ],
        queryFn: async (): Promise<SuperAdminDataLookupListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(
                ApiConfig.queries.superAdmin.data.lookups.endpoints.apartments,
                {
                    tenantId,
                    searchText,
                    hotelId: hotelId ?? undefined,
                    take: 100,
                    skip: 0,
                },
            );
            const response = await axiosInstance.get<SuperAdminDataLookupListResponseDto>(url);
            return response.data;
        },
        enabled: Boolean(tenantId),
        placeholderData: keepPreviousData,
    });
};

export const useSuperAdminDataHotelsLookupApi = (tenantId: string | null, searchText?: string) => {
    const axiosInstance = useAxiosAuth();

    return useQuery({
        queryKey: [ApiConfig.queries.superAdmin.data.lookups.queryKeys.hotels, tenantId, searchText],
        queryFn: async (): Promise<SuperAdminDataLookupListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(
                ApiConfig.queries.superAdmin.data.lookups.endpoints.hotels,
                { tenantId, searchText, take: 100, skip: 0 },
            );
            const response = await axiosInstance.get<SuperAdminDataLookupListResponseDto>(url);
            return response.data;
        },
        enabled: Boolean(tenantId),
    });
};
